import { render } from "./ModalEditQuestions.vue?vue&type=template&id=20fa620d&scoped=true"
import script from "./ModalEditQuestions.vue?vue&type=script&lang=js"
export * from "./ModalEditQuestions.vue?vue&type=script&lang=js"

import "./ModalEditQuestions.vue?vue&type=style&index=0&id=20fa620d&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fa620d"]])

export default __exports__